import { LanguageService } from "../../services/languages";
import { useTranslation } from 'react-i18next';
import Select from "@mui/material/Select";
import LanguageIcon from '@mui/icons-material/Language';
import MenuItem from "@mui/material/MenuItem";
import FormControl from '@mui/material/FormControl';
import { Box, Icon } from "@mui/material";

export const LanguageList = () => {

    const { i18n } = useTranslation();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', marginRight: 2 }}>
            <Icon sx={{ mr: 0.5 }}>
                <LanguageIcon />
            </Icon>
            <FormControl variant="standard">
                <Select
                    defaultValue={LanguageService[0].code}
                    onChange={(e) => i18n.changeLanguage(e.target.value)
                    }
                    inputProps={{
                        name: 'language',
                        id: 'uncontrolled-native',
                    }}
                    sx={{
                        color: "background.paper",
                        borderColor: "background.paper",
                        marginRight: 2,
                        minWidth: 90,
                    }}
                >
                    {LanguageService.map(({ code, label }) => (
                        <MenuItem key={code} value={code}>
                            {label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box >  
    );
}